export const SIGN_IN_USER_STARTED = "SIGN_IN_USER_STARTED";
export const SIGN_IN_USER_SUCCESS = "SIGN_IN_USER_SUCCESS";
export const SIGN_IN_USER_FAILED = "SIGN_IN_USER_FAILED";
export const SIGN_OUT_USER = "SIGN_OUT_USER";
export const SIGN_IN_TOKEN = "SIGN_IN_TOKEN";
export const GET_STAFF_STARTED = "GET_STAFF_STARTED";
export const GET_STAFF_SUCCESS = "GET_STAFF_SUCCESS";
export const GET_STAFF_FAILED = "GET_STAFF_FAILED";
export const UPDATE_CURRENT_STAFF = "UPDATE_CURRENT_STAFF";
